import { getAccessInfo, switchIdentity } from "../service/permission";
import { adaptAccessInfo } from "../utils/identity";
import { resolveLandingPath } from "../utils/permission";
import {
  syncWorkspaceAfterBootstrap,
  syncWorkspaceAfterSwitch,
} from "../utils/workspaceSync";

const getInitialState = () => ({
  initialized: false,
  initializing: false,
  identityList: [],
  currentIdentity: null,
  identityType: "",
  identityCount: 0,
  vendorId: "",
  vendorName: "",
  permissionCodes: [],
  permissionModules: [],
  authorizedModules: [],
  unauthorizedModules: [],
  hasAnyPermission: false,
  needSelectIdentity: false,
  identitySelectionMode: "",
  isUnionUser: false,
  landingPath: "/view/home",
  pagePermissionDenied: false,
  identitySwitching: false,
  logDownloadLoading: false,
  subAccountQuota: 20,
  subAccountCurrentCount: 0,
  subAccountQuotaReached: false,
});

const permission = {
  name: "permission",
  state: getInitialState(),
  reducers: {
    setState(state, payload) {
      return {
        ...state,
        ...payload,
      };
    },
    resetState() {
      return getInitialState();
    },
  },
  effects: () => ({
    async bootstrapAsync(accessInfoResponse) {
      this.setState({ initializing: true });
      try {
        const response = accessInfoResponse || (await getAccessInfo());
        const adapted = adaptAccessInfo(response || {});
        const landingPath = adapted.isUnionUser
          ? resolveLandingPath({
            identityType: adapted.identityType,
            permissionCodes: adapted.permissionCodes,
            needSelectIdentity: adapted.needSelectIdentity,
          })
          : "/view/no_access?scene=union_not_open";

        this.setState({
          ...adapted,
          landingPath,
          identitySelectionMode: adapted.needSelectIdentity ? "initial" : "",
          initialized: true,
          initializing: false,
          pagePermissionDenied: false,
        });
        syncWorkspaceAfterBootstrap(adapted);
        return {
          ...adapted,
          landingPath,
        };
      } catch (error) {
        this.setState({
          initialized: true,
          initializing: false,
          isUnionUser: false,
        });
        throw error;
      }
    },
    async refreshAccessInfoAsync() {
      const response = await getAccessInfo();
      const adapted = adaptAccessInfo(response || {});
      const landingPath = adapted.isUnionUser
        ? resolveLandingPath({
          identityType: adapted.identityType,
          permissionCodes: adapted.permissionCodes,
          needSelectIdentity: adapted.needSelectIdentity,
        })
        : "/view/no_access?scene=union_not_open";
      this.setState({
        ...adapted,
        landingPath,
        identitySelectionMode: adapted.needSelectIdentity ? "initial" : "switch",
        initialized: true,
        initializing: false,
      });
      return {
        ...adapted,
        landingPath,
      };
    },
    async switchIdentityAsync(payload) {
      this.setState({ identitySwitching: true });
      try {
        await switchIdentity(payload);
        const data = await this.refreshAccessInfoAsync();
        syncWorkspaceAfterSwitch(data);
        this.setState({ identitySwitching: false });
        return data;
      } catch (error) {
        this.setState({ identitySwitching: false });
        throw error;
      }
    },
  }),
};

export default permission;
